import 'mlmi-library'
import AjaxifyGrid, { AjaxifyGrid_CoreInit } from 'mlmi-library/components/grid/v1/ajaxify-grid'
import Carousel, { Carousel_CoreInit } from 'mlmi-library/components/carousel/v1/carousel'
import Accordion from 'mlmi-library/components/accordion/v1/accordion'
import Popup from 'mlmi-library/components/popup/v1/popup'
import Form from 'mlmi-library/components/form/v1/form'
import { Form_CoreInit } from 'mlmi-library/components/form/v1/form-builder'
import 'mlmi-library/components/form/v1/form-steps'
import 'mlmi-library/components/floating-label/v1/floating-label'
import 'mlmi-library/components/select/v1/select'
import 'mlmi-library/components/file-input/v1/file-input'
import 'mlmi-library/utils/inbound'
import Burger from 'mlmi-library/components/burger/v1/burger'
import 'mlmi-library/components/fixed-content/v2/fixed-content'
import Mobile from 'mlmi-library/modules/mobile/v1/mobile'
import Scrollbar from 'mlmi-library/components/scrollbar/v1/scrollbar'
import 'mlmi-library/plugins/scroll-to'
import 'mlmi-library/components/video-loop/v1/video-loop'
import { Header_CoreInit } from 'mlmi-library/components/header/v1/header'
import { CoreDetect_WebP } from 'mlmi-library/utils/device'
import 'jquery.easing'

export { AjaxifyGrid, AjaxifyGrid_CoreInit, Carousel, Carousel_CoreInit, Accordion, Popup, Form, Form_CoreInit, Burger, Mobile, Scrollbar, Header_CoreInit }

const pluginsContext = require.context('./plugins', false, /\.js$/);
pluginsContext.keys().forEach(key => {
  const pluginModule = pluginsContext(key)
})

CoreDetect_WebP()